document.addEventListener("DOMContentLoaded", function() {
    function getCookieValue(key) {
        let value = document.cookie.match(
            new RegExp(
                "(?:^|; )" +
                key.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
                "=([^;]*)"
            )
        );
        return value ? value[1] : false;
    }

    function initCountryPicker() {
        let modal = document.querySelector(".theme-redirect-modal"),
            isActive = false,
            modalCloseButton = document.querySelector(".theme-redirect-modal-container__close"),
            targetLinks = document.querySelectorAll(".muse__store-link"),
            modalOverlay = document.querySelector(".theme-redirect-modal__overlay"),
            DOMbody = document.querySelector("body"),
            DOMhtml = document.querySelector("html"),
            modalNavLinks = document.querySelectorAll(".theme-redirect-modal__nav-container-nav-item a"),
            modalRegionLinks = document.querySelectorAll(".theme-redirect-modal__regions-container-mobile-nav-item a"),
            modalRegionsContainer = document.querySelectorAll(".theme-redirect-modal__regions-container");

        function doOpen() {
            modal.classList.add("theme-redirect-modal--active"), modalOverlay.classList.add("theme-redirect-modal__overlay--active"), DOMbody.classList.add("modal--active"), DOMhtml.classList.add("modal--active"), isActive = !0
        }
        targetLinks.forEach(p => p.addEventListener("click", function() {
            doOpen();
        })), modalCloseButton.addEventListener("click", function() {
            doClose()
        }), modalNavLinks.forEach(p => {
            p.addEventListener("click", function(s) {
                let l = document.getElementById(p.dataset.id);
                modalRegionsContainer.forEach(f => {
                    f.classList.remove("active_tab")
                }), modalNavLinks.forEach(f => {
                    f.classList.remove("active_link")
                }), p.classList.add("active_link"), l.classList.add("active_tab")
            })
        }), modalRegionLinks.forEach(p => {
            p.addEventListener("click", function(s) {
                let l = document.getElementById(p.dataset.id);
                modalRegionsContainer.forEach(f => {
                    f.classList.remove("active_tab")
                }), modalRegionLinks.forEach(f => {
                    f.classList.remove("active_link")
                }), p.classList.add("active_link"), l.classList.add("active_tab")
            })
        }), document.addEventListener("keydown", p => {
            isActive && p.key === "Escape" && doClose()
        });

        
        function doClose() {
            modal.classList.remove("theme-redirect-modal--active"), modalOverlay.classList.remove("theme-redirect-modal__overlay--active"), DOMbody.classList.remove("modal--active"), DOMhtml.classList.remove("modal--active"), isActive = !1
        }
        // let b = document.querySelectorAll("[data-tab='desktop']"),
        //     v = document.querySelectorAll("[data-tab='mobile']"),
        //     C = document.querySelectorAll(".theme-redirect-modal__tab-content"),
        //     _ = 0,
        //     m = "theme-redirect-modal__tab--active",
        //     w = "theme-redirect-modal__tab-content--active";
        // b.forEach((p, s) => {
        //     p.addEventListener("click", () => {
        //         b[_].classList.toggle(m), b[s].classList.toggle(m), C[_].classList.toggle(w), C[s].classList.toggle(w), _ = s
        //     })
        // }), v.forEach((p, s) => {
        //     p.addEventListener("click", () => {
        //         b[_].classList.toggle(m), b[s].classList.toggle(m), C[_].classList.toggle(w), C[s].classList.toggle(w), _ = s
        //     })
        // });

        /* Disable the popup on page load, don't check the user's country
        // Country Check
        fetch("http://api.ipstack.com/check?access_key=f3287ae9e3cbb4c36c2cfff6b8b9fe28").then(r => r.json()).then(r => {
            let currStoreCookie = getCookieValue("_muse_store"),
                prevStoreCookie = getCookieValue("_muse_store_prev");

            if (r.country_code === 'US' && ["https://sandbox.choosemuse.com", "https://choosemuse.com"].includes(window.location.origin) && currStoreCookie === 'us') {
                return;
            } else if (r.country_code === 'CA' && ["https://ca.choosemuse.com"].includes(window.location.origin) && currStoreCookie === 'ca') {
                return;
            } else if (['eu', 'intl'].includes(currStoreCookie) && prevStoreCookie) {
                return;
            } else {
                doOpen();
            }
        })
        //*/
    }

    let regions = ["eu", "ca", "intl", "us"],
        keyPageURLs = [
            "/cart",
            "/checkout",
            "/products",
            "/pages/premium-subscription",
            "/pages/muse-connect",
            "/pages/compare",
            "/pages/shop",
            "/pages/shop-in-bulk",
            "/pages/shop-accessories",
        ],
        currentURL = window.location,
        redirectIfProductionSite = () => {
            window.location.origin !== "https://sandbox.choosemuse.com" && (handleCurrentStoreDiscountAndURL(), initCountryPicker(), createClickHandlerForCountryButtons());
        },
        handleCurrentStoreDiscountAndURL = () => {
            let currStoreCookie = getCookieValue("_muse_store"),
                prevStoreCookie = getCookieValue("_muse_store_prev"),
                matchedRegion = regions.find((k) => k === currStoreCookie),
                subdomain = getSubdomain(),
                matchedSubdomain = regions.find((k) => k === subdomain),
                forcedParam = getForcedURLParam(),
                matchedForced = regions.find((k) => k === forcedParam),
                urlDiscount = new URLSearchParams(window.location.search).get("discount");

            matchedForced ? setRegion(forcedParam) : matchedSubdomain && prevStoreCookie != subdomain ? setRegion(subdomain) : matchedRegion ? setRegion(currStoreCookie) : (setRegion("us"), (subdomain = "us")),
                urlDiscount &&
                location.hostname === "choosemuse.com" &&
                (regions
                    .filter((regionKey) => regionKey !== "us")
                    .forEach((regionKey) => {
                        let iframe = document.createElement("iframe");
                        iframe.setAttribute(
                                "src",
                                encodeURI(`https://${regionKey}.choosemuse.com/discount/${urlDiscount}`)
                            ),
                            iframe.setAttribute("style", "display: none;"),
                            iframe.setAttribute("id", "discount-iframe"),
                            iframe.setAttribute("name", "discount-iframe"),
                            document.body.appendChild(iframe);
                    }),
                    setTimeout(() => {
                        //! Disable redirect for now
                        // window.location.href = encodeURI(`https://choosemuse.com/discount/${urlDiscount}`);
                    }, 1e3)),
                isCurrentURLKeyPage() ?
                (subdomain === "choosemuse" && (subdomain = "us"), i(subdomain)) :
                currentURL.pathname === "/search" &&
                currentURL.hostname !== "choosemuse.com" &&
                instantRedirect("search", "us");
        },
        i = (h) => {
            let currStoreCookie = getCookieValue("_muse_store");
            if (h != currStoreCookie) {
                let y = window.location.pathname.includes("/products"),
                    a = getIsCartOrCheckoutURL(),
                    m = currentURL.pathname;
                a == "cart" ?
                    instantRedirect("cart", currStoreCookie) :
                    a == "checkout" ?
                    instantRedirect("checkout", currStoreCookie) :
                    y ?
                    instantRedirect("products", currStoreCookie) :
                    keyPageURLs.find((l) => l == m) && instantRedirect("page-with-pricing", currStoreCookie);
            }
        },
        instantRedirect = (keyTarget, regionTarget) => {
            let reg = regionTarget === "us" ? "shop" : regionTarget,
                path;
            keyTarget == "cart" ?
                (path = "/cart") :
                keyTarget == "checkout" ?
                (path = "/checkout") :
                keyTarget == "search" ?
                (path = `/search${window.location.search}`) :
                (path = currentURL.pathname),
                regions.includes(reg) && location.hostname !== `https://${reg}.choosemuse.com${path}` ?
                (window.location.href = `https://${reg}.choosemuse.com${path}`) :
                reg === "shop" &&
                location.hostname !== "choosemuse.com" &&
                (window.location.href = `https://choosemuse.com${path}`);
        },
        getIsCartOrCheckoutURL = () => {
            let match;
            return (
                window.location.pathname == "/cart" ?
                (match = "cart") :
                window.location.pathname.includes("/checkouts/") &&
                (match = "checkout"),
                match
            );
        },
        getForcedURLParam = () => {
            let searchParams = window.location.search;
            return new URLSearchParams(searchParams).get("force");
        },
        isCurrentURLKeyPage = () => {
            return keyPageURLs
                .map((keyPage) => window.location.pathname.includes(keyPage))
                .reduce((prev, curr) => prev || curr);
        },
        getSubdomain = () => window.location.host.split(".")[0],
        setRegion = (newRegion, setLocation) => {
            let detectedRegion,
                headerStoreFlags = document.querySelectorAll("img.header__store-flag"),
                headerStoreLabels = document.querySelectorAll("span.header__store-content"),
                l = location.hostname === "localhost" || location.hostname === "127.0.0.1" ? location.hostname : ".choosemuse.com",
                _ = regions.map(reg => {
                    let matching = headerStoreFlags.length > 0 ? headerStoreFlags[0].src.match(`assets/${reg}`) : false;
                    if (matching) {
                        detectedRegion = reg;
                        return matching;
                    } else {
                        if (location.hostname.startsWith(`${reg}.`)) { // Non-US
                            detectedRegion = reg;
                        } else if (location.hostname === 'choosemuse.com' && reg === 'us') {
                            detectedRegion = reg;
                        }
                        return detectedRegion;
                    }
                }).reduce((S, k) => S || k),
                cookieExpiration = new Date(Date.now() + 864e5);
            cookieExpiration = cookieExpiration.toUTCString();
            document.cookie = `_muse_store=${newRegion}; expires=${cookieExpiration}; path=/; secure; domain=${l}`;
            detectedRegion && detectedRegion !== newRegion && (document.cookie = `_muse_store_prev=${detectedRegion}; expires=${cookieExpiration}; path=/; secure; domain=${l}`),
                setLocation && localStorage.setItem("muse_location", newRegion),
                headerStoreLabels.forEach(
                    (label) => {
                        label.textContent = newRegion === "eu" ? "EU / UK Store" : `${newRegion.toUpperCase()} Store`
                    }
                );
        },
        createClickHandlerForCountryButtons = () => {
            document
                .querySelectorAll(".theme-redirect-modal__tab-country button")
                .forEach((flag) => {
                    flag.addEventListener("click", function(e) {
                        let flagLocation = flag.dataset.locationLink;
                        setRegion(flagLocation, true);
                        if (isCurrentURLKeyPage()) {
                            window.location.reload()
                        } else {
                            // var reg = (flagLocation === 'us') ? '' : `${flagLocation.toLowerCase().trim()}.`;
                            // var path = window.location.pathname + window.location.search;
                            // setRegion(flagLocation.toLowerCase().trim());
                            // window.location.href = `https://${reg}choosemuse.com${path}`;

                            var reg = (flagLocation === 'us') ? '' : `${flagLocation.toLowerCase().trim()}.`;
                            var path = window.location.pathname + window.location.search;
                            var l = location.hostname === "localhost" || location.hostname === "127.0.0.1" ? location.hostname : ".choosemuse.com";
                            var cookieExpiration = new Date(Date.now() + 864e5);
                            var detectedRegion = regions.map(reg => {
                                if (location.hostname.startsWith(`${reg}.`)) { // Non-US
                                    return reg;
                                } else if (location.hostname === 'choosemuse.com' && reg === 'us') {
                                    return reg;
                                }
                                return null;
                            }).reduce((prev,curr) => prev || curr, null);
                            document.cookie = `_muse_store_prev=${detectedRegion}; expires=${cookieExpiration}; path=/; secure; domain=${l}`;
                            window.location.href = `https://${reg}choosemuse.com${path}`;
                        }
                        hideRedirectModal();
                    });
                });
        },
        hideRedirectModal = () => {
            document
                .querySelector(".theme-redirect-modal")
                .classList.remove("theme-redirect-modal--active"),
                document.querySelector("body").classList.remove("modal--active"),
                document.querySelector("html").classList.remove("modal--active"),
                document
                .querySelector(".theme-redirect-modal__overlay")
                .classList.remove("theme-redirect-modal__overlay--active");
        };
    return redirectIfProductionSite();
});